// import { load } from "@core/util/third-party-scripts";
// load method from the @core/util is build to load only files with .js and .css extension

/**
 * loadScript is accepting src files with no extenstion
 * @param {string} src
 * @param {{
 *  id?: string,
 * }} [options]
 * @returns {Promise<void>}
 */
export const loadScript = (src, options = {}) => new Promise((resolve, reject) => {
  const scriptEl = document.createElement('script');

  scriptEl.async = true;
  scriptEl.addEventListener('load', () => resolve(), { once: true });
  scriptEl.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });

  if (options.id) scriptEl.id = options.id;
  scriptEl.src = src;

  document.body.appendChild(scriptEl);
});

export default loadScript;
